module.exports = __webpack_public_path__ + "static/media/partnersBackGround4.ef90182c.jpg";